import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["block", "children", "className", "danger", "ghost", "hover", "htmlType", "icon", "loading", "prefixCls", "shape", "size", "type", "forwardRef", "onClick", "isGray", "prefix", "suffix"];

/* eslint-disable no-underscore-dangle */
import * as React from 'react';
import Spinner from '@bedrock/icons-react/Spinner';
import { composeRef } from "rc-util/es/ref";
import { ButtonGroupContext } from './Group';
import { ConfigContext, SizeContext } from '../ConfigProvider';
import Wave from '../utils/wave';

function isUnborderedButtonType(type) {
  return ['link', 'text', 'text-neutral', 'text-subtle', 'text-subtle-primary'].indexOf(type) !== -1;
}
/**
 * @desc 按钮
 * @link https://bedrock.netease.com/components/button
 */


var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _getPrettyCls;

  var _React$useContext = React.useContext(ConfigContext),
      getPrettyCls = _React$useContext.getPrettyCls;

  var _React$useContext2 = React.useContext(ButtonGroupContext),
      groupSize = _React$useContext2.size,
      groupShape = _React$useContext2.shape;

  var contextSize = React.useContext(SizeContext);

  var block = props.block,
      children = props.children,
      className = props.className,
      danger = props.danger,
      ghost = props.ghost,
      hover = props.hover,
      htmlType = props.htmlType,
      icon = props.icon,
      propLoading = props.loading,
      prefixCls = props.prefixCls,
      propShape = props.shape,
      propSize = props.size,
      type = props.type,
      forwardRef = props.forwardRef,
      onClick = props.onClick,
      _props$isGray = props.isGray,
      isGray = _props$isGray === void 0 ? false : _props$isGray,
      prefix = props.prefix,
      suffix = props.suffix,
      rest = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(propLoading),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var iconNode = loading ? /*#__PURE__*/React.createElement(Spinner, {
    spin: true
  }) : icon;
  var size = propSize || groupSize || contextSize;
  var shape = propShape || groupShape;
  var delayTimeout; // if (['circle', 'circle-outline'].indexOf(shape as string) > -1) {
  //   console.warn(
  //     `Button desperated: shape is not supported with 'circle' or 'circle-outline', use 'round' and 'round-outline' instead`,
  //   );
  // }

  var classString = getPrettyCls('btn', prefixCls, className)((_getPrettyCls = {
    type: type,
    danger: danger
  }, _defineProperty(_getPrettyCls, "".concat(hover, "-hover"), !!hover), _defineProperty(_getPrettyCls, "size", size), _defineProperty(_getPrettyCls, shape, shape), _defineProperty(_getPrettyCls, "block", block), _defineProperty(_getPrettyCls, "loading", loading), _defineProperty(_getPrettyCls, 'icon-only', !children && children !== 0 && !!icon), _defineProperty(_getPrettyCls, 'background-ghost', ghost), _defineProperty(_getPrettyCls, "gray", isGray), _getPrettyCls));

  var handleClick = function handleClick(e) {
    if (loading) {
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  React.useEffect(function () {
    if (propLoading && typeof propLoading !== 'boolean') {
      clearTimeout(delayTimeout);
    }

    if (propLoading && typeof propLoading !== 'boolean' && propLoading.delay) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      delayTimeout = window.setTimeout(function () {
        return setLoading(!!propLoading);
      }, propLoading.delay);
    } else if (propLoading !== loading) {
      setLoading(!!propLoading);
    }
  });
  var elRef = React.useRef(null); // @ts-ignore composeRef内部有filter的处理

  var refForDom = composeRef(elRef, forwardRef);
  React.useImperativeHandle(ref, function () {
    return {
      el: elRef.current
    };
  });

  if ('href' in rest) {
    return (
      /*#__PURE__*/
      // @ts-ignore
      React.createElement("a", _objectSpread({
        className: classString,
        ref: refForDom,
        onClick: handleClick
      }, rest), iconNode, children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
    );
  }

  if (isUnborderedButtonType(type)) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/button-has-type
      React.createElement("button", _objectSpread({
        className: classString,
        // @ts-ignore
        ref: refForDom,
        type: htmlType,
        onClick: handleClick
      }, rest), iconNode, children !== undefined && /*#__PURE__*/React.createElement("span", null, children), suffix)
    );
  }

  return /*#__PURE__*/React.createElement(Wave, null, /*#__PURE__*/React.createElement("button", _objectSpread({
    className: classString,
    // @ts-ignore
    ref: refForDom,
    type: htmlType,
    onClick: handleClick
  }, rest), prefix, iconNode, children !== undefined && /*#__PURE__*/React.createElement("span", null, children), suffix));
});
Button.defaultProps = {
  block: false,
  ghost: false,
  htmlType: 'button',
  loading: false,
  danger: false,
  type: 'secondary'
};
export default Button;